import React, { useMemo, useState } from 'react';

export default function SafeImage({
  src,
  alt = '',
  fallback = 'https://picsum.photos/seed/shaheen-fallback/900/650',
  className,
  style,
  loading = 'lazy'
}) {
  const [failed, setFailed] = useState(false);

  const finalSrc = useMemo(() => {
    if (!src || failed) return fallback;
    return src;
  }, [src, failed, fallback]);

  return (
    <img
      src={finalSrc}
      alt={alt}
      className={className}
      style={style}
      loading={loading}
      onError={() => setFailed(true)}
    />
  );
}
